import Head from 'next/head';
import { OpportunitiesBrowser } from '@/components/OpportunitiesBrowser';
import { ConsumerModeCallout } from '@/components/ConsumerModeCallout';
import { useSiteSettings } from '@/lib/hooks/useSiteSettings';

const HARD_CODED_FILTERS = {
  categories: ['consumer'],
};

export default function WhatsOnPage() {
  const { settings, isLoading: siteSettingsIsLoading } = useSiteSettings();
  if (siteSettingsIsLoading) return null;
  return (
    <>
      <Head>
        <title>What&apos;s On | Sizzlenz</title>
        <meta
          name="description"
          content="Events, offers, experiences, and promotions for brands, businesses and places"
        />
      </Head>
      <OpportunitiesBrowser
        title="What's On"
        subtitle={
          <>Events, offers, experiences, and promotions for brands, businesses and places</>
        }
        showInterestCount="non-zero"
        showStatus
        hardCodedFilters={HARD_CODED_FILTERS}
        signInRedirectTo="/whatson"
        mapConfig={{
          initialCenter: settings?.whatson?.initialMapCenter,
          initialZoom: settings?.whatson?.initialMapZoom,
        }}
        showOwner
      />
    </>
  );
}
